import { render, staticRenderFns } from "./AffiliateGroups.edit.vue?vue&type=template&id=ec1d0e5a&"
import script from "./AffiliateGroups.edit.vue?vue&type=script&lang=js&"
export * from "./AffiliateGroups.edit.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateGroups.edit.vue?vue&type=style&index=0&id=ec1d0e5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports